module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_oda-8d8eeb43801c0a3b2955ffe64157a76c.jpg";